import { openDB } from 'idb';

const DB_NAME = 'carteiraDB';
const STORE_NAME = 'imagens';

export const initDB = () =>
  openDB(DB_NAME, 1, {
    upgrade(db) {
      db.createObjectStore(STORE_NAME);
    },
  });

export const salvarImagemLocal = async (id, base64String) => {
  const db = await initDB();
  await db.put(STORE_NAME, base64String, id);
};

export const carregarImagemLocal = async (id) => {
  const db = await initDB();
  return await db.get(STORE_NAME, id);
};

export const removerImagemLocal = async (id) => {
  const db = await initDB();
  return await db.delete(STORE_NAME, id);
};
